/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsProjectFilterBase extends models.AppSecopsFilterBase {
    getFixupPrototypeFunction() { return AppSecopsProjectFilterBase.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsProjectFilterBase>): AppSecopsProjectFilterBase {
        let obj = Object.assign(new AppSecopsProjectFilterBase(), model);
        AppSecopsProjectFilterBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsProjectFilterBase>): AppSecopsProjectFilterBase {
        if (!model) return null;
        return AppSecopsProjectFilterBase.newInstance(<AppSecopsProjectFilterBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsProjectFilterBase) {
        if (!obj) return;

        models.AppSecopsProjectFilterBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsProjectFilterBase): boolean {
        if (models.AppSecopsFilterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsProjectFilterBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Name of SBOMs linked to a project.
     */
    sbom_names: Array<string>;

    /**
     * ID of applications to which the project belongs
     */
    application_ids: Array<string>;

    /**
     * Name of applications to which the project belongs
     */
    application_names: Array<string>;

    /**
     * Filter projects based on SBOM association status
     */
    sbom_filter: models.AppSecopsProjectSbomFilter;

    /**
     * Search based on name, description and SBOM name
     */
    search: string;

}
